import { create } from 'zustand';
import { createDefaultFilterSlice, DefaultFilterState } from '../defaultFilterSlice';
import { persist } from 'zustand/middleware';

export const useFacilitiesListFiltersStore = create<DefaultFilterState>()(
  persist(
    (...a) => ({
      ...createDefaultFilterSlice(...a),
    }),
    {
      name: 'clients.facilities',
    },
  ),
);
